import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  FlexBox,
  InputCheckbox,
  InputText,
  Spacer,
  TextDense
} from '@directsoftware/ui-kit-web-admin';
import {
  FIELD_KIND,
  MAX_INITIALS_LENGTH,
  isAddendumFieldComplete,
  normalizeAddendumFields
} from '../../utils/contract-addendum';

const AddendumFields = ({ fields, values, signature, onChange }) => {
  const addendumFields = normalizeAddendumFields(fields);
  if (addendumFields.length === 0) return null;
  const fieldValues = values || {};
  const completedCount = addendumFields.filter(field =>
    isAddendumFieldComplete(field, fieldValues, signature)
  ).length;
  const updateField = (fieldId, value) =>
    onChange({ ...fieldValues, [fieldId]: value });
  return (
    <Box
      style={{
        border: '1px solid #e5e2e2',
        borderRadius: '8px',
        padding: '16px'
      }}
    >
      <FlexBox justifyContent="space-between" alignItems="center" gap="m">
        <TextDense weight="semibold">Complete this agreement</TextDense>
        <TextDense>
          {`${completedCount} of ${addendumFields.length} complete`}
        </TextDense>
      </FlexBox>
      {addendumFields.map(field => (
        <Box key={field.id}>
          <Spacer size="m" />
          {field.kind === FIELD_KIND.initials && (
            <FlexBox alignItems="center" justifyContent="space-between" gap="m">
              <TextDense>{`Initial ${field.label}`}</TextDense>
              <Box style={{ flex: '0 0 120px' }}>
                <InputText
                  value={fieldValues[field.id] || ''}
                  onChange={e =>
                    updateField(
                      field.id,
                      e.target.value.slice(0, MAX_INITIALS_LENGTH)
                    )
                  }
                  placeholder="Initials"
                  removeBottomSpacer
                  isDense
                />
              </Box>
            </FlexBox>
          )}
          {field.kind === FIELD_KIND.acknowledgement && (
            <InputCheckbox
              isChecked={fieldValues[field.id] === true}
              onChange={() =>
                updateField(field.id, fieldValues[field.id] !== true)
              }
            >
              {field.label}
            </InputCheckbox>
          )}
          {field.kind === FIELD_KIND.signature && (
            <TextDense>
              {signature
                ? `${field.label || 'Signature'}: signed with your e-signature`
                : `${field.label ||
                    'Signature'}: add your e-signature below to sign`}
            </TextDense>
          )}
        </Box>
      ))}
    </Box>
  );
};
AddendumFields.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      kind: PropTypes.string,
      label: PropTypes.string
    })
  ),
  values: PropTypes.object,
  signature: PropTypes.object,
  onChange: PropTypes.func.isRequired
};
AddendumFields.defaultProps = { fields: [], values: {}, signature: null };
export default AddendumFields;
